












import TitleBar from '@/modules/core/components/TitleBar.vue';
import CardComponent from '@/modules/core/components/CardComponent.vue';
import BreadcrumbsTable from '../components/BreadcrumbsTable.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    TitleBar,
    CardComponent,
    BreadcrumbsTable,
  },
})
export default class BreadcrumbList extends Vue {
  public get titleStack(): string[] {
    return ['Admin', 'Ligne de vie'];
  }
}
